import axios from "axios";
import { useEffect, useState } from "react";
import delicon from './images/cross.png';
import editicon from './images/st5.png';
import arrow from './images/arrow.png';
export default function Archive()
{
    let [archiveData,setArchiveData]=useState([]);
    let [pageData,setPageData]=useState([]);
    let [pagesize,setPageSize]=useState(20);
    let [pageno,setPageNo]=useState(1);
    let [totalpage,setTotalPage]=useState(0);
    let [msg,setMsg]=useState("");    
    function loadArchiveData()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"archives.php",config).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setArchiveData(reply.data.data);
                setPageData(reply.data.data.slice(0,pagesize));
                setTotalPage(Math.ceil(reply.data.data.length/pagesize));
                setPageNo(1);
            }
        });
    }
    function sortData(col)
    {
        let arr=[...archiveData];
        if(col=="sname" ||col=="cname"||col=="vname"||col=="archivesite"||col=="savedat"||col=="savedby")
        {
            arr.sort((e1,e2)=>e1[col].trim().toUpperCase()>e2[col].trim().toUpperCase()?1:-1);
        }
        else
        {
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[col]);
                let d2=new Date(e2[col]);
                return d1>d2?1:-1;
            });
        }
        setArchiveData(arr);
        setPageData(arr.slice(0,pagesize));
        setPageNo(1);
    }
    function showPage(pp)
    {
        
        setPageData(archiveData.slice((pp-1)*pagesize,(pp)*pagesize));
        setPageNo(pp);
    }
    function moveNext()
    {
        if(pageno<totalpage)
        {
            let x=pageno;
            x++;
            showPage(x);
        }
    }
    function movePrevious()
    {
        if(pageno>1)
        {
            let x=pageno;
            x--;
            showPage(x);
        }
    }
    useEffect(()=>{loadArchiveData()},[]);
    return(
        <div className="container">
            <div className="card mt-3 shadow">
                <div className="card-header text-center text-white bg-primary">
                    <b>Archive Details</b>                    
                </div>
                <div className="card-body p-3">                                        
                    <div style={{overflow:'auto',fontSize:'12px'}}>
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Sample Name <img src={arrow} alt="" onClick={()=>{sortData('sname')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Client Name <img src={arrow} alt="" onClick={()=>{sortData('cname')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Vendor Name <img src={arrow} alt="" onClick={()=>{sortData('vname')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Vendor Address</th>
                                    <th>Archive Site <img src={arrow} alt="" onClick={()=>{sortData('archivesite')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Archive Date <img src={arrow} alt="" onClick={()=>{sortData('archivedate')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Saved At <img src={arrow} alt="" onClick={()=>{sortData('savedat')}} style={{width:'10px',cursor:"pointer"}} /></th>
                                    <th>Saved By <img src={arrow} alt="" onClick={()=>{sortData('savedby')}} style={{width:'10px',cursor:"pointer"}} /></th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                {pageData.map((e,i)=>
                                    <tr key={e.id}>
                                        <td >{pagesize*(pageno-1)+(i+1)}</td>
                                        <td>{e.sname}</td>
                                        <td>{e.cname}</td>
                                        <td>{e.vname}</td>
                                        <td>{e.address}</td>
                                        <td>{e.archivesite}</td>
                                        <td>{e.archivedate}</td>
                                        <td>{e.savedat}</td>
                                        <td>{e.savedby}</td>                                        
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td><input type="button" value="<<<" onClick={movePrevious} className="btn btn-warning" /></td>
                                    <td colSpan="7" className="text-center">Page {pageno+ " / "+ totalpage}</td>
                                    <td><input type="button" value=">>>" onClick={moveNext} className="btn btn-warning" /></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}